import React, {useState, useCallback} from 'react';
import {Box, Flex, HStack, useTheme} from '@chakra-ui/react';
import {TextG12, TextG14, TextG16, TextG24} from '../../../components/typography';
import useAuth from '../../../hooks/useAuth';
import {QRCodeSVG} from 'qrcode.react';
import {useNavigate} from 'react-router-dom';
import Modal from '../../../components/Modals/Modal';

const ProfileHeader = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const {user} = useAuth();
  const [showQR, setShowQR] = useState(false);

  const isMember = user?.hasActiveMembership;
  const profileLink = location.origin + '/neighbor/' + user?.id + '?action=connect';
  const handle = user?.handle;

  const handleShare = useCallback(async () => {
    const shareData = {
      title: 'Connect with me',
      text: `Connect with @${handle} on ${location.hostname}`,
      url: profileLink,
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch {
        // user cancelled or share failed — fallback to clipboard
      }
    } else {
      await navigator.clipboard.writeText(profileLink);
      alert('Link copied to clipboard!');
    }
  }, [profileLink, handle]);

  return (
    <>
      <Box px={4} pt={6} pb={2}>
        <Flex justify="space-between" align="center">
          <HStack spacing={3} align="center">
            <TextG24 fontWeight="700">Profile</TextG24>
            <Box
              px={3}
              py={1}
              bg="#262626" //{isMember ? '#1A1A1A' : '#F4F4F4'}
              color="white" //{isMember ? 'white' : '#1A1A1A'}
              borderRadius="8px">
              <TextG14 mt="0" fontWeight="500" letterSpacing="0.3px">
                {isMember ? 'Insider' : 'Free Member'}
              </TextG14>
            </Box>
          </HStack>

          <HStack spacing={3}>
            <Box
              w="44px"
              h="44px"
              as="button"
              onClick={() => setShowQR(true)}
              p={2}
              borderRadius="100%"
              border="1px solid #E5E5E5"
              bg="white"
              boxShadow="0 0 16px 0 rgba(0, 0, 0, 0.08)"
              _active={{bg: '#F4F4F4'}}>
              <i className="fi fi-rr-qrcode" aria-hidden="true" style={{fontSize: '20px', display: 'block'}} />
            </Box>
            <Box
              w="44px"
              h="44px"
              as="button"
              onClick={() => navigate('/profile')}
              p={2}
              borderRadius="100%"
              border="1px solid #E5E5E5"
              bg="white"
              boxShadow="0 0 16px 0 rgba(0, 0, 0, 0.08)"
              _active={{bg: '#F4F4F4'}}>
              <i className="fi fi-rr-settings" aria-hidden="true" style={{fontSize: '22px', display: 'block'}} />
            </Box>
          </HStack>
        </Flex>
      </Box>

      <Modal
        show={showQR}
        parentCallback={() => setShowQR(false)}
        closeButton
        closeButtonPosition="right"
        isCentered
        header={
          <TextG24 fontSize="26px" fontWeight="700" textAlign="center" w="100%">
            Connect With Me
          </TextG24>
        }>
        <Flex direction="column" align="center" pb={6} gap={4}>
          <Box p={2} borderRadius="12px">
            <QRCodeSVG value={profileLink} size={240} />
          </Box>
          {handle && (
            <TextG16 fontWeight="600" color="#1A1A1A">
              @{handle}
            </TextG16>
          )}
          <TextG14 color="#6A6A6A" textAlign="center">
            You can share this code with your neighbors.
          </TextG14>
          <Box
            as="button"
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={2}
            bg="#C9136B"
            color="white"
            py={3}
            px={8}
            w="100%"
            borderRadius="100px"
            boxShadow="0 -4px 0 0 rgba(0, 0, 0, 0.25) inset"
            onClick={handleShare}
            _hover={{bg: '#A8105A'}}
            _active={{transform: 'scale(0.98)'}}
            transition="all 0.2s">
            <i className="fi fi-rr-share" aria-hidden="true" style={{fontSize: '16px', display: 'flex'}} />
            <TextG16 fontWeight="600">Share Your Link</TextG16>
          </Box>
        </Flex>
      </Modal>
    </>
  );
};

export default ProfileHeader;
